export const RoleAccesByRoute = {
    "/editorial": ["Editor"],
    "/news_panel": ["Editor"],
    "/comunidad": ["Editor", "Aficionado/Fan", "Artista/Banda"],
    "/perfil": ["*"],
};
